import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input';

export const VehicleModelFormPanel = ({
  editingVehicleModelId,
  brandOptions,
  register,
  errors,
  onSubmit,
  onCancel,
}) => (
  <>
    <h4 className="parameters-page__create-title">
      {editingVehicleModelId
        ? 'Editar modelo de vehículo'
        : 'Crear nuevo modelo de vehículo'}
    </h4>
    <div className="parameters-page__create-fields parameters-page__create-fields--city">
      <div
        className="row"
        style={{ width: '100%', alignItems: 'flex-start' }}
      >
        <Input
          bootstrap="col-12 col-md-3"
          label={
            editingVehicleModelId ? 'Marca de vehículo' : 'Marca de vehículo *'
          }
          type="select"
          name="brandId"
          options={brandOptions}
          register={register}
          placeholder=""
          errors={errors?.brandId?.message}
          disabled={Boolean(editingVehicleModelId)}
        />
        <Input
          bootstrap="col-12 col-md-3"
          label="Nombre del modelo *"
          type="text"
          name="modelName"
          register={register}
          placeholder="Ej: Corolla, Aveo, etc."
          errors={errors?.modelName?.message}
        />
        <div
          className="col-12 col-md-auto buttons-center-container"
          style={{ marginTop: '32px' }}
        >
          <ActionButton
            label={editingVehicleModelId ? 'Guardar cambios' : 'Guardar'}
            action={onSubmit}
          />
          <AltButton label="Cancelar" action={onCancel} />
        </div>
      </div>
    </div>
  </>
);
